import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../hooks/useTranslation.js';
import { localizePath } from '../utils/localizedRoutes.js';
import { companyContact } from '../config/company.js';
import { brandText } from './BrandText.jsx';
import { CONSENT_OPEN_EVENT } from '../config/consent.js';

// Laid out like the foot of the company's letters: company and address,
// contact, managing directors; then the pages and the legal links.
const Footer = () => {
  const { t, currentLang } = useTranslation();
  const toLocalizedPath = (path) => localizePath(path, currentLang);
  const country = companyContact.country[currentLang] || companyContact.country.en;

  // Reopens the consent dialog with the current choice (D-HP-SITE-027).
  const handleCookieSettingsClick = (e) => {
    e.preventDefault();
    window.dispatchEvent(new Event(CONSENT_OPEN_EVENT));
  };

  const pages = [
    { path: '/team', label: t.nav?.team },
    { path: '/veridion', label: t.nav?.veridion },
    { path: '/agenticdev', label: t.nav?.agenticdev },
    { path: '/kyveil', label: t.nav?.kyveil },
    { path: '/teaching', label: t.nav?.teaching },
    { path: '/finance', label: t.nav?.finance },
    { path: '/quantum', label: t.nav?.quantum },
    { path: '/events', label: t.nav?.events }
  ];

  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <div className="site-footer__grid">
          <div>
            <p className="site-footer__name">{brandText(t.nav?.title)}</p>
            <p>{companyContact.street}</p>
            <p>{companyContact.postalCode} {companyContact.city}</p>
            <p>{country}</p>
          </div>

          <div>
            <p><a href={`https://${companyContact.website}`}>{brandText(companyContact.website)}</a></p>
            <p><a href={`mailto:${companyContact.email}`}>{brandText(companyContact.email)}</a></p>
            {companyContact.phones.map((phone) => (
              <p key={phone}><a href={`tel:${phone.replace(/\s+/g, '')}`}>{phone}</a></p>
            ))}
          </div>

          <div>
            <p className="site-footer__label">{t.footer?.managingDirectors}</p>
            {companyContact.managingDirectors.map((name) => (
              <p key={name}>{name}</p>
            ))}
          </div>

          <nav aria-label={t.footer?.servicesTitle}>
            {pages.map((page) => (
              <p key={page.path}><Link to={toLocalizedPath(page.path)}>{page.label}</Link></p>
            ))}
          </nav>

          <nav aria-label={t.footer?.legal?.title}>
            <p><Link to={toLocalizedPath('/impressum')}>{t.footer?.legal?.imprint}</Link></p>
            <p><Link to={toLocalizedPath('/privacy')}>{t.footer?.legal?.privacy}</Link></p>
            <p><Link to={toLocalizedPath('/ai-transparency')}>{t.footer?.legal?.aiTransparency}</Link></p>
            <p>
              <button type="button" onClick={handleCookieSettingsClick}>
                {t.footer?.legal?.cookieSettings}
              </button>
            </p>
          </nav>
        </div>

        <p className="site-footer__copyright">
          &copy; {new Date().getFullYear()} {brandText(t.nav?.title)}. {t.footer?.copyright}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
